import { Component } from "react";
import { Button, Card, Divider, Flex, Modal, Spin, Tabs } from "antd";
import {
  FileProtectOutlined,
  CloseOutlined,
  QrcodeOutlined,
  ExceptionOutlined,
  UploadOutlined,
} from "@ant-design/icons";

import { getFuncConfirmTransaction } from "../../utils/funcCallback";
import ComponentVerifySlip from "./components/componentVerifySlip";
import ComponentVerifySlipOut from "./components/componentVerifySlip_out";
import { t } from "i18next";
import { confirmSwal, openNotification } from "../../utils";
import Swal from "sweetalert2";
import { Note } from "./components/note";

export class ContentVerifySlip extends Component {
  instance = null;
  constructor(props) {
    super(props);
    this.state = {
      selectedForm: "Deposit (with slip)",
      loading: false,
      spinner: false,
      isConfirm: false,
      uuid: null,
      dataResults: null,
      showContent: false,
      showTypeVerify: "With slip",
      activeTabs: "1",
    };
    this.handleChangeLoading = this.handleChangeLoading.bind(this);
    this.confirm = this.confirm.bind(this);
    this.handleConfirmTransaction = this.handleConfirmTransaction.bind(this);
    this.handleShowBtnConfirm = this.handleShowBtnConfirm.bind(this);
  }

  componentDidMount() {
    this.setState({ showTypeVerify: "With slip" });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.show && this.props.show) {
      this.setState({ showTypeVerify: "With slip" }, () => this.confirm());
    }
  }

  handleChangeLoading = (state) => {
    this.setState({ loading: state });
  };
  handleShowBtnConfirm = (state, item) => {
    this.setState({ dataResults: item, spinner: state });
  };

  onChange = (key) => {
    this.setState({ activeTabs: key });
  };

  mainContainWithQRcode() {
    let { uuid, showContent } = this.state;
    let { resAllDataMerchang } = this.props;
    return (
      <ComponentVerifySlip
        uuid={uuid}
        t={t}
        handleChangeLoading={this.handleChangeLoading}
        handleShowBtnConfirm={this.handleShowBtnConfirm}
        handleConfirmTransaction={this.handleConfirmTransaction}
        resAllDataMerchang={resAllDataMerchang}
        showContent={showContent}
      />
    );
  }
  mainContainWithoutQRcode() {
    let { uuid, showContent } = this.state;
    let { resAllDataMerchang } = this.props;
    return (
      <ComponentVerifySlipOut
        t={t}
        uuid={uuid}
        handleChangeLoading={this.handleChangeLoading}
        showContent={showContent}
        handleShowBtnConfirm={this.handleShowBtnConfirm}
        resAllDataMerchang={resAllDataMerchang}
        handleConfirmTransaction={this.handleConfirmTransaction}
      />
    );
  }

  handleConfirmTransaction = async (item) => {
    if (!item?.id) {
      Swal.fire({
        title: t("error_occurred"),
        text: t("No data"),
        icon: "error",
      });
      this.handleCloseModel();
      return;
    }
    let onConfirm = await confirmSwal("question", t("ยืนยันการทำรายการ"));
    if (!onConfirm) {
      openNotification("info", t("success"), ("ยกเลิกการทำรายการแล้ว"));
      this.handleCloseModel();
      return;
    }

    let postData = {
      verifyId: item?.id,
    };
    try {
      const res = await getFuncConfirmTransaction(postData);
      if (res.status === "MATCHED" || res.status === "SUCCESS") {
        this.setState(
          {
            spinner: false,
          },
          () => {
            this.handleCloseModel();
            this.props.fetchData();
          }
        );

        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 500);

        return res;
      } else {
        this.setState({
          spinner: false,
        });
      }
    } catch (error) {
      console.error("Failed to confirm transaction:", error);
      this.setState({ spinner: false, isConfirm: false });
    }
  };
  resetState = () => {
    this.setState({
      spinner: false,
    });
  };
  handleCloseModel = () => {
    const { handleClose } = this.props;
    if (this.instance) {
      this.instance.destroy();
      handleClose();
      this.resetState();
    }
  };
  confirm() {
    const { spinner, activeTabs } = this.state;
    this.instance = Modal.confirm({
      title: (
        <>
          <FileProtectOutlined /> {t("Verify Slip")}
        </>
      ),
      icon: null,
      style: { top: 20 },
      width: 590,
      closable: () => this.handleCloseModel(),
      content: (
        <>
          <div className="mb-3">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <Card
                className="pt-0 mt-0"
                style={{ border: "none", boxShadow: "none" }}
              >
                <div>
                  <Divider />
                  <Tabs
                    defaultActiveKey={activeTabs}
                    onChange={this.onChange}
                    items={[QrcodeOutlined, ExceptionOutlined].map(
                      (Icon, i) => {
                        const id = String(i + 1);
                        return {
                          key: id,
                          label: id === "1" ? t("With slip") : t("With out slip"),
                          children: (
                            <>
                              {/* แบบมี สลิป */}
                              <Spin spinning={spinner} tip="Loading...">
                                {id === "1" ? (
                                  <>
                                    <div
                                      className={`${id === "1" ? "show animate" : "d-none"
                                        }`}
                                      id="With slip"
                                    >
                                      {this.mainContainWithQRcode()}
                                    </div>
                                  </>
                                ) : id === "2" ? (
                                  <>
                                    {/* แบบไม่มี สลิป */}
                                    <div
                                      className={`${id === "2" ? "show animate" : ""
                                        }`}
                                      id="With out slip"
                                    >
                                      {this.mainContainWithoutQRcode()}
                                    </div>
                                  </>
                                ) : null}
                              </Spin>
                            </>
                          ),
                          icon: <Icon />,
                        };
                      }
                    )}
                  />
                </div>
              </Card>
            </div>
          </div>
          {/* Note */}
          <Note t={t} />
        </>
      ),
      footer: [
        <Flex gap="middle" justify="end" horizontal>
          <Button danger onClick={() => this.handleCloseModel()}>
            <CloseOutlined /> {t("Close")}
          </Button>
        </Flex>,
      ],
      maskClosable: false,
    });
  }

  render() {
    const { t, accessible_verify } = this.props;
    return (
      <>
      {accessible_verify && <Button  icon={<UploadOutlined />} onClick={() => accessible_verify ? this.confirm() : alert(t("You don't have permission to verify slip"))}>
        {t("Verify Slip")}
      </Button>}
      
      </>
    );
  }
}
